import React, { Component } from "react";
import { Table, Segment } from "semantic-ui-react";
import { setDateFormat } from "../../../../Global/CustomFunctions";

class EmployeeFamily extends Component {
  renderEmployeeFamily(family) {
    if (family && family.length > 0) {
      return family.map(emp => {
        return (
          <Table.Row key={emp.Id}>
            <Table.Cell>
              {emp.FirstName}
            </Table.Cell>
            <Table.Cell>
              {emp.LastName}
            </Table.Cell>
            <Table.Cell>
              {emp.RelationName}
            </Table.Cell>
            <Table.Cell>
              {emp.Gender}
            </Table.Cell>
            <Table.Cell>
              {setDateFormat(emp.DOB).format("LL")}
            </Table.Cell>
            <Table.Cell>
              {emp.CNIC}
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  render() {
    let { family } = this.props;
    return (
      <Segment.Group className="BasicInfoCnt">
        <Segment basic>
          <h1 className="textStyleHeading">Employee Family</h1>
          <Table singleLine>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>First Name</Table.HeaderCell>
                <Table.HeaderCell>Last Name</Table.HeaderCell>
                <Table.HeaderCell>Relation</Table.HeaderCell>
                <Table.HeaderCell>Gender</Table.HeaderCell>
                <Table.HeaderCell>D.O.B</Table.HeaderCell>
                <Table.HeaderCell>CNIC#</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderEmployeeFamily(family)}
            </Table.Body>
          </Table>
        </Segment>
      </Segment.Group>
    );
  }
}

export default EmployeeFamily;
